import { makeAutoObservable } from 'mobx';
import type { Filter } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import {cmApi } from '@src/api';
import type { CmApi} from '@src/api';

export type PageTypes = 'generalReport' | 'packageLevel' | 'controlLevel' | 'stepLevel' | 'errorDetails';

export interface PagesParamInterface {
  controlType: PageTypes;
  reportPackageCodeCm?: string;
  execNum?: string;
  maxExecNum?: string;
  filters?: Filter[][];
}

interface InfoDrawer {
  packageCode?: string;
  control?: string;
  ctrlName?: string;
  stepName?: string;
  controlDescription?: string;
  step?: string;
  stepDescription?: string;
  formula?: string;
  ksCodeFns?: string;
}

class DataControlStore {
  pagesParam: PagesParamInterface[] = [{ controlType: 'generalReport' }];

  breadcrumbs: string[] = [];

  filters: {
    [key in PageTypes]?: { [index: string]: string | undefined };
  } = {};

  infoDrawer: InfoDrawer | null = null;

  needUpdateFilters = true;

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  get lastPagesParam() {
    return this.pagesParam[this.pagesParam.length - 1] ?? {};
  }

  setFilters = (value: { [index: string]: string | undefined }, name: PageTypes) => {
    this.filters = { ...this.filters, [name]: value };
  };

  setInfoDrawer = (value: InfoDrawer | null) => {
    this.infoDrawer = value;
  };

  setNeedUpdateFilters = (value: boolean) => {
    this.needUpdateFilters = value;
  };

  addBreadcrumbs = (breadcrumbs: string[], all = false) => {
    if (all) {
      this.breadcrumbs = [...breadcrumbs];
    } else {
      this.breadcrumbs = [...this.breadcrumbs, ...breadcrumbs];
    }
  };

  removeBreadcrumb = (count = 1) => {
    this.breadcrumbs = [...this.breadcrumbs.slice(0, -count)];
  };

  addPage = (params: PagesParamInterface[], all = false) => {
    if (all) {
      this.pagesParam = [...params];
    } else {
      this.pagesParam = [...this.pagesParam, ...params];
    }
  };

  setLastPage = (params: PagesParamInterface) => {
    this.pagesParam[this.pagesParam.length - 1] = { ...this.pagesParam[this.pagesParam.length - 1], ...params };
  };

  removePage = (all = false, count = 1) => {
    if (all) {
      this.pagesParam = [];
    } else {
      this.pagesParam = [...this.pagesParam.slice(0, -count)];
    }
  };

  clear = () => {
    this.pagesParam = [{ controlType: 'generalReport' }];
    this.breadcrumbs = [];
    this.infoDrawer = null;
    this.filters = {};
  };
}

export const dataControlStore = new DataControlStore({ api: cmApi });
